import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';
import CaseStudy from "../../../images/industries/retail/Retail-casestudy-app.webp"
import {LazyLoadImage} from "react-lazy-load-image-component";

function Globalmarket(props) {
    return (
        <section className="tekrevol_dark_bg  tekgrip_img_uper  p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
                        <div className="example" data-text="MoCuts App">
                            <h2>MoCuts App</h2>
                        </div>
                        <p>MoCuts Pro is an online marketplace for booking registered barbers, beauticians, and other
                            day-to-day barber services. TekRevol partnered up with the client to build an online B2C
                            one-stop shop empowering people to book their favorite barbers and beauticians from the
                            comfort of their homes.</p>
                        <div className="btn_talk">
                            <Link to="/case-studies/mocuts"
                                  className="border_btn" aria-label="TekRevol Contact">View Full Casestudy</Link>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto text-center">
                        <div className="tekgrip_tabs_image">
                            <LazyLoadImage
                                src={CaseStudy}
                                effect="blur" alt="CaseStudy" className="img-fluid"
                            />
                        </div>


                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Globalmarket;